/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
import React from "react";
import DivContainerBody from "../../../components/DivContainerBody";
import HeadTittle from "../../../components/HeadTittle";
import routes from "../../../Routes/routes";
import MyApartmentDetailsApp from "../Functionality/MyApartmentDetailsApp";
import MyApartmentInformation from "./MyApartmentInformation";
import MyApartmentDetailsMainTabs from "./MyApartmentDetailsMainTabs";

const MyApartmentDetails = () => {
    const {
        t,
        buildingDetail,
        containerRef,
        containerHeight
    } = MyApartmentDetailsApp();


    return (
        <>
            <HeadTittle name={t('details')} link={routes.myApartment.list} hidden={false} />

            <DivContainerBody>
                <div className={"row mb-4 minh-645px"} ref={containerRef}>
                    <div className='col-sm-12 col-md-6 col-lg-5 col-xl-4 mb-4 minh-645px' style={{height:containerHeight }}>
                        <MyApartmentInformation
                            t={t}
                            buildingDetail={buildingDetail}
                            containerHeight={containerHeight}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-7 col-xl-8 mb-4 minh-645px' style={{height:containerHeight }}>
                        <MyApartmentDetailsMainTabs
                            t={t}
                            buildingDetail={buildingDetail}
                            containerHeight={containerHeight}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default MyApartmentDetails;
